module.exports = __webpack_public_path__ + "img/reloj.7c8132eb.svg";